<template>
  <div class="warehouse-inbound-page">
    <!-- 面包屑：返回入库管理 -->
    <div class="bread-crumbs">
      <div class="bread-crumbs-item" @click="onBack">入库管理</div>
      <Icon type="ios-arrow-forward" size="14" />
      <div class="bread-crumbs-item active">新增入仓</div>
    </div>

    <div class="page-content">
      <!-- 商品选择 -->
      <div class="section">
        <div class="section-title">选择商品</div>
        <div class="select-product-bar">
          <Button class="select-btn" @click="openProductSelect">选择商品</Button>
          <span v-if="selected_products.length" class="select-tips">
            已选 <span class="count">{{ selected_products.length }}</span> 件商品
          </span>
        </div>

        <!-- 已选商品规格数量（二维矩阵：颜色竖排、尺码横排） -->
        <template v-if="selected_products.length">
          <div
            v-for="(sp, idx) in selected_products"
            :key="`sp${sp.id}`"
            class="selected-product"
          >
            <div class="selected-head">
              <div class="sp-info">
                <img :src="sp.image" alt="" class="sp-img" />
                <div class="sp-text">
                  <div class="sp-name">{{ sp.name }}</div>
                  <div class="sp-no">款号：{{ sp.style_no || '-' }}</div>
                </div>
              </div>
              <span class="sp-remove" @click="removeSelected(idx)">移除</span>
            </div>

            <div class="matrix-table">
              <table>
                <thead>
                  <tr>
                    <th class="corner">颜色 \ 尺码</th>
                    <th v-for="(size, si) in sp.sizes" :key="`size${si}`">{{ size }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, ri) in sp.matrix" :key="`row${ri}`">
                    <td class="color-cell">{{ row.color }}</td>
                    <td v-for="(cell, ci) in row.cells" :key="`cell${ci}`">
                      <input
                        v-model="cell.send_num"
                        type="number"
                        min="0"
                        placeholder="0"
                        class="matrix-input"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </template>
        <div v-else class="empty-tip">请选择需要入仓的商品</div>
      </div>

      <!-- 物流信息 -->
      <div class="section">
        <div class="section-title">物流信息</div>
        <div class="info-row">
          <div class="info-label">物流公司</div>
          <Select
            v-model="form_data.logistics_id"
            placeholder="请选择物流公司"
            class="form-select"
            @on-change="onCompanyChange"
          >
            <Option
              v-for="(item, index) in logistics_company_list"
              :key="index"
              :value="item.id"
            >{{ item.name }}</Option>
          </Select>
        </div>
        <div class="info-row">
          <div class="info-label">运单号</div>
          <input
            v-model="form_data.logistics_no"
            type="text"
            placeholder="请输入运单号"
            class="form-input"
          />
        </div>
        <div class="info-row">
          <div class="info-label">寄出时间</div>
          <DatePicker
            class="date-picker"
            type="date"
            format="yyyy-MM-dd"
            placeholder="选择寄出时间"
            :value="sendTimeValue"
            @on-change="onSendTimeChange"
            transfer
          ></DatePicker>
        </div>
        <div class="info-row">
          <div class="info-label">备注</div>
          <input
            v-model="form_data.remark"
            type="text"
            placeholder="选填"
            class="form-input"
          />
        </div>
      </div>

      <div class="page-footer">
        <button class="cancel-btn" @click="onBack">取消</button>
        <button
          class="confirm-btn"
          :disabled="submitting"
          :loading="submitting"
          @click="onSubmit"
        >
          确认寄出
        </button>
      </div>
    </div>

    <!-- 商品选择弹窗 -->
    <warehouse-product-select
      :value.sync="is_product_select_show"
      :selected-items="selected_products"
      @confirm="onProductConfirm"
    />
  </div>
</template>

<script>
import {
  WarehouseInboundCreate,
  logisticsCompanyList,
} from "@/api/index";
import util from "@/utils/util";
import WarehouseProductSelect from "./WarehouseProductSelect.vue";
export default {
  name: "WarehouseInbound",
  components: {
    WarehouseProductSelect,
  },
  data() {
    return {
      selected_products: [],
      is_product_select_show: false,
      logistics_company_list: [],
      form_data: {
        logistics_id: "",
        logistics_company: "",
        logistics_no: "",
        remark: "",
      },
      sendTimeValue: "",
      submitting: false,
      // 建单幂等键：本次建单（含失败重试）固定不变，服务端据此避免重复建单
      request_id: "",
    };
  },
  mounted() {
    this.request_id = util.uuid();
    this.onGetLogisticsCompanyList();
  },
  methods: {
    onBack() {
      this.$emit("back");
    },
    async onGetLogisticsCompanyList() {
      try {
        const { code, msg, data } = await logisticsCompanyList();
        if (code > 0) {
          this.$layer.msg(msg);
          return;
        }
        this.logistics_company_list = data;
      } catch (e) {
        console.log("err-logistics-company-list", e);
      }
    },
    onCompanyChange(id) {
      const target = this.logistics_company_list.find(
        (item) => item.id == id
      );
      this.form_data.logistics_company = target ? target.name : "";
    },
    openProductSelect() {
      this.is_product_select_show = true;
    },
    // 商品弹窗确认回填：已存在商品保留其矩阵数值，新商品按 specs 构建二维矩阵
    onProductConfirm(products) {
      this.selected_products = products.map((p) => {
        const exist = this.selected_products.find((sp) => sp.id == p.id);
        if (exist && exist.matrix) return exist;
        if (p.specs) return this.buildProduct(p);
        return p;
      });
    },
    // 由扁平 specs（[{spec_id, attr1_name=尺码, attr2_name=颜色}]）构建二维矩阵
    buildProduct(item) {
      const specs = item.specs || [];
      const colors = [];
      const sizes = [];
      specs.forEach((s) => {
        const color = s.attr2_name || "-";
        const size = s.attr1_name || "-";
        if (!colors.includes(color)) colors.push(color);
        if (!sizes.includes(size)) sizes.push(size);
      });
      const matrix = colors.map((color) => ({
        color,
        cells: sizes.map((size) => {
          const spec = specs.find(
            (s) => (s.attr2_name || "-") === color && (s.attr1_name || "-") === size
          );
          return {
            size,
            spec_id: spec ? spec.spec_id : null,
            send_num: 0,
          };
        }),
      }));
      return {
        id: item.id,
        uuid: item.uuid,
        name: item.name,
        image: item.image,
        style_no: item.style_no,
        colors,
        sizes,
        matrix,
      };
    },
    removeSelected(idx) {
      this.selected_products.splice(idx, 1);
    },
    onSendTimeChange(date) {
      this.sendTimeValue = date;
      this.form_data.send_time = date
        ? Math.floor(new Date(date).getTime() / 1000)
        : 0;
    },
    async onSubmit() {
      if (this.submitting) return;
      if (!this.selected_products.length) {
        this.$layer.msg("请选择商品");
        return;
      }
      if (!this.form_data.logistics_company) {
        this.$layer.msg("请填写物流公司");
        return;
      }
      if (!this.form_data.logistics_no) {
        this.$layer.msg("请填写运单号");
        return;
      }
      // 由二维矩阵展开为扁平 [{spec_id, send_num}]，过滤未填数量的规格
      const product_list = this.selected_products
        .map((sp) => {
          const spec_data = [];
          sp.matrix.forEach((row) => {
            row.cells.forEach((cell) => {
              if (cell.send_num > 0 && cell.spec_id) {
                spec_data.push({ spec_id: cell.spec_id, send_num: cell.send_num });
              }
            });
          });
          return { product_id: sp.id, spec_data };
        })
        .filter((p) => p.spec_data.length > 0);
      if (!product_list.length) {
        this.$layer.msg("请填写寄出数量");
        return;
      }
      const param = {
        product_list,
        logistics_company: this.form_data.logistics_company,
        logistics_no: this.form_data.logistics_no,
        send_time: this.form_data.send_time || Math.floor(Date.now() / 1000),
        remark: this.form_data.remark,
        request_id: this.request_id,
      };
      this.submitting = true;
      try {
        // 携带 request_id：网络重试/重复提交时服务端幂等返回首次单据，不会重复建单
        await WarehouseInboundCreate(param);
        // 本次建单已成功，重置幂等键，避免后续新建单被服务端当作重复请求
        this.request_id = util.uuid();
        this.$layer.msg("新增入仓成功");
        this.$emit("success");
      } catch (e) {
        console.log("e-submit", e);
        if (e && e.msg) this.$layer.msg(e.msg);
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.warehouse-inbound-page {
  display: flex;
  flex-direction: column;
  margin-top: 22px;
  user-select: none;
  .bread-crumbs {
    display: flex;
    align-items: center;
    column-gap: 8px;
    .bread-crumbs-item {
      color: #999999;
      font-size: 14px;
      cursor: pointer;
      &:hover,
      &.active {
        color: #333333;
      }
    }
  }
  .page-content {
    width: 100%;
    background: #ffffff;
    padding: 24px 30px 30px;
    margin-top: 19px;
    .section {
      margin-bottom: 24px;
      .section-title {
        font-size: 14px;
        font-weight: 600;
        color: #1a1a1a;
        margin-bottom: 14px;
      }
      .select-product-bar {
        display: flex;
        align-items: center;
        margin-bottom: 14px;
        .select-btn {
          background: #ff5967;
          border-color: #ff5967;
          color: #ffffff;
          border-radius: 20px;
          padding: 5px 20px;
        }
        .select-tips {
          margin-left: 16px;
          font-size: 13px;
          color: #666666;
          .count {
            color: #ff5967;
            font-weight: 600;
          }
        }
      }
      .empty-tip {
        text-align: center;
        color: #999999;
        padding: 30px 0;
      }
      .selected-product {
        border: 1px solid #f0f0f0;
        border-radius: 8px;
        padding: 14px;
        margin-bottom: 14px;
        .selected-head {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 12px;
          .sp-info {
            display: flex;
            align-items: center;
            .sp-img {
              width: 48px;
              height: 48px;
              border-radius: 5px;
              object-fit: cover;
              margin-right: 12px;
              border: 1px solid #f0f0f0;
              flex-shrink: 0;
            }
            .sp-text {
              .sp-name {
                font-size: 14px;
                font-weight: 500;
                color: #1a1a1a;
              }
              .sp-no {
                font-size: 12px;
                color: #999999;
                margin-top: 4px;
              }
            }
          }
          .sp-remove {
            font-size: 13px;
            color: #ff5967;
            cursor: pointer;
          }
        }
        .matrix-table {
          overflow-x: auto;
          table {
            width: 100%;
            border-collapse: collapse;
            thead {
              th {
                background: #f7f7f7;
                padding: 8px 0;
                font-size: 13px;
                color: #666666;
                font-weight: 500;
                text-align: center;
                border: 1px solid #f0f0f0;
                &.corner {
                  min-width: 120px;
                }
              }
            }
            tbody {
              td {
                padding: 6px;
                text-align: center;
                border: 1px solid #f0f0f0;
                .color-cell {
                  font-size: 13px;
                  color: #333333;
                }
                .matrix-input {
                  width: 72px;
                  height: 32px;
                  border: 1px solid #e6e6e6;
                  border-radius: 6px;
                  text-align: center;
                  outline: none;
                  font-size: 13px;
                  &:focus {
                    border-color: #ff5967;
                  }
                }
              }
              .color-cell {
                font-size: 13px;
                color: #333333;
                font-weight: 500;
              }
            }
          }
        }
      }
    }
    .info-row {
      display: flex;
      align-items: center;
      margin-bottom: 14px;
      .info-label {
        width: 90px;
        flex-shrink: 0;
        font-size: 13px;
        color: #666666;
      }
      .form-input {
        flex: 1;
        height: 36px;
        padding: 0 12px;
        border: 1px solid #e6e6e6;
        border-radius: 6px;
        outline: none;
        font-size: 13px;
        &:focus {
          border-color: #ff5967;
        }
      }
      .form-select {
        flex: 1;
      }
      .date-picker {
        flex: 1;
        ::v-deep .ivu-input {
          border: 1px solid #e6e6e6;
          border-radius: 6px;
          height: 36px;
        }
      }
    }
    .page-footer {
      padding-top: 16px;
      border-top: 1px solid #f0f0f0;
      display: flex;
      justify-content: flex-end;
      .cancel-btn {
        width: 120px;
        height: 40px;
        border-radius: 20px;
        border: 1px solid #e3e3e3;
        background: #ffffff;
        color: #999999;
        font-size: 14px;
        margin-right: 12px;
        cursor: pointer;
      }
      .confirm-btn {
        width: 140px;
        height: 40px;
        border-radius: 20px;
        border: none;
        background: #ff5967;
        color: #ffffff;
        font-size: 14px;
        cursor: pointer;
        &:hover {
          background: #ff5067;
        }
        &:disabled {
          background: #ffb3b9;
          cursor: not-allowed;
        }
      }
    }
  }
}
</style>
